import Link from 'next/link'

import styles from './StaticPage.module.css'

const HOST = process.env.NEXT_PUBLIC_HOST

// Okruszki strony informacyjnej; items: [{ name, url }], ostatni element to bieżąca strona.
export default function StaticCrumbs ({ items }) {
    return (
        <nav aria-label="Okruszki" className={styles.crumbs}>
            <ol>
                { items.map((item, i) => (
                    <li key={item.url}>
                        { i === items.length - 1
                            ? <span aria-current="page">{item.name}</span>
                            : <Link href={item.url} prefetch={false}>{item.name}</Link> }
                    </li>
                )) }
            </ol>
        </nav>
    )
}

export function breadcrumbLd (items) {
    return {
        '@type': 'BreadcrumbList',
        itemListElement: items.map((item, i) => ({ '@type': 'ListItem', position: i + 1, name: item.name, item: HOST + item.url })),
    }
}
